import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./productOutFormChild/Inputs";

export default function ProductOutForm({ isEdit }) {
  return (
    <ArrayInput
      source="product_outs"
      defaultValue={[
        {
          product_id: undefined,
          name: undefined,
          stock: undefined,
          mutation: undefined,
        },
      ]}
    >
      <SimpleFormIterator
        getItemLabel={(index) => `#${index + 1}`}
        // disableAdd
        // disableClear
        // disableRemove
        // disableReordering
        fullWidth
        sx={{
          "& .RaSimpleFormIterator-action": {
            display: "flex",
            flexDirection: "column",
          },
          "& .RaSimpleFormIterator-action > .button-reorder": {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <FormDataConsumer>
          {(props) => Inputs({ isEdit, ...props })}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
